import { render, staticRenderFns } from "./MigrationButtonArea.vue?vue&type=template&id=9512caf0&scoped=true&"
import script from "./MigrationButtonArea.vue?vue&type=script&lang=js&"
export * from "./MigrationButtonArea.vue?vue&type=script&lang=js&"
import style0 from "./MigrationButtonArea.vue?vue&type=style&index=0&id=9512caf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9512caf0",
  null
  
)

export default component.exports